<template>
<div>
  <el-container>
    <el-header>
      <el-page-header @back="goBack" content="训练详情">
      </el-page-header>
    </el-header>
    <el-main style="padding: 0px" >
      <div  v-loading="loading">
      <el-card class="box-card" body-style="border:0" v-model="datas">
        <div  class="text item">
          得分：{{datas.total_score}}
        </div>
        <div  class="text item">
          用时：{{formatSeconds(datas.total_time)}}
        </div>
        <div  class="text item">

          评价：{{datas.evaluate?datas.evaluate:'无'}}
        </div>
        <div  class="text item">
          错误：{{datas.mistake?datas.mistake:'无'}}
        </div>
        <div  class="text item">
          训练时间：{{datas.created_at}}
        </div>
      </el-card>
        <div class="demo-image__placeholder" v-if="datas.learn_id==13||datas.learn_id==33">
          <div class="block" v-for="(image,val) in tableData">
            <el-image :src="GLOBAL.BASE_URL+'/'+image"></el-image>
          </div>
        </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :show-header=false
        v-else
      >
        <el-table-column
          width="180"
          v-for="(v,i) in tableData[0]"
        >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row[i] }}</span>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </el-main>
  </el-container>

  </div>

</template>

<script>
    export default {
        name: "practiceDetail",
        data(){
          return {
              datas:[],
              loading:true,
              tableData:[]
          };
        },
        methods: {
            getPractice(){
              this.$http.getScoreDetail({'id':this.$route.query.id}).then(res=>{
                  if (res.code!==0){
                      this.datas=res.data;
                      this.tableData=JSON.parse(res.data.detail)
                      console.log( this.tableData)
                      this.loading=false;
                  }else {
                      this.$message.error(res.message)
                  }
              })
            },
            goBack() {
                this.$router.back()
            }
        },
        created() {
            this.getPractice();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/User/PracticeDetail.vue